import { render, staticRenderFns } from "./newsStory.vue?vue&type=template&id=f6e53536&scoped=true"
import script from "./newsStory.vue?vue&type=script&lang=js"
export * from "./newsStory.vue?vue&type=script&lang=js"
import style0 from "./newsStory.vue?vue&type=style&index=0&id=f6e53536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e53536",
  null
  
)

export default component.exports